<template>
<!-- new code -->
    <div class="wrapper-main-content">
        <!-- sidebar -->
            <div class="sidebar">
                <side-bar
                    :step="step"
                    :sidebarListLinks="sidebarListLinks"
                ></side-bar>
            </div>
        <!-- sidebar ends -->

        <!-- form -->
        <div class="main_content-form">
            <div class="manager-form-box position-relative p-4">
                    <div class="card-body">
                        <h1 class="head-title font-weight-bold text-center">What kind of job is this?</h1>
                        <p class="text-center sub-text">Please Create Quote or Work Order</p>
                        <b-form @submit.prevent="componentFormSubmitted" class="mt-5">
                            <b-form-group class="stack-radio-btns position-relative">
                            <div class="radio-btns-div">
                                <div class="radioBtn">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="options"
                                        id="option1"
                                        autocomplete="off"
                                        v-model="jobType"
                                        :checked="workOrder ? false : true"
                                        :disabled="$route.params.id != 'new' ? true:false"/>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="user-icon"
                                    >
                                        <path
                                            d="M11.7365 9.472C14.348 9.472 16.4725 7.34748 16.4725 4.736C16.4725 2.12453 14.348 0 11.7365 0C9.12501 0 7.00049 2.12453 7.00049 4.736C7.00049 7.34748 9.12501 9.472 11.7365 9.472Z"
                                            fill="#4682B4"
                                        />
                                        <path
                                            d="M18.5825 11.7671C18.5805 11.7664 18.5766 11.765 18.5746 11.7645C17.958 11.6138 16.0697 11.3497 16.0697 11.3497C15.8565 11.2841 15.6287 11.397 15.552 11.6073L12.7097 19.406C12.5457 19.8559 11.9094 19.8559 11.7455 19.406L8.90311 11.6073C8.84121 11.4374 8.68089 11.3309 8.50909 11.3309C8.46836 11.3309 6.52679 11.6032 5.8804 11.7639C4.1141 12.2031 3 13.94 3 15.7501V22.2391C3 23.2116 3.78836 24 4.76081 24H19.6927C20.6651 24 21.4535 23.2116 21.4535 22.2391V15.7285C21.4534 13.9262 20.2957 12.3268 18.5825 11.7671Z"
                                            fill="#4682B4"
                                        />
                                        <path
                                            d="M13.2994 11.201C13.186 11.0774 13.0202 11.0153 12.8524 11.0153H11.6011C11.4333 11.0153 11.2674 11.0775 11.1541 11.201C10.9785 11.3924 10.9529 11.6688 11.0776 11.8848L11.7466 12.8932L11.4334 15.5349L12.0501 17.1753C12.1102 17.3403 12.3435 17.3403 12.4036 17.1753L13.0203 15.5349L12.7071 12.8932L13.3761 11.8848C13.5006 11.6688 13.475 11.3924 13.2994 11.201Z"
                                            fill="#4682B4"
                                        />
                                    </svg>

                                    <label class="btn btn-secondary mb-0" for="option1">Quote</label>
                                </div>

                                <div class="radioBtn">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="options"
                                        id="option2"
                                        autocomplete="off"
                                        value="work-order"
                                        v-model="jobType"
                                        :checked="workOrder ? true : false"
                                        :disabled="$route.params.id != 'new' ? true:false"
                                    />
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="set-icon"
                                    >
                                        <path
                                            d="M4.71557 9.44414C5.21064 9.44414 5.69699 9.3666 6.16552 9.21723L8.95028 12L12 8.95099L9.21654 6.16519C9.7531 4.48855 9.31223 2.63072 8.06171 1.38067C7.17149 0.490218 5.98641 0 4.7281 0C4.02504 0 3.32008 0.159314 2.68755 0.460913C2.59212 0.506382 2.52529 0.595073 2.5074 0.699063C2.49002 0.803054 2.52348 0.908601 2.59773 0.983547L5.52773 3.91413C5.74393 4.13015 5.86322 4.41697 5.86322 4.72142C5.86322 5.02665 5.74375 5.31295 5.52773 5.52897C5.09731 5.96067 4.3448 5.96067 3.91361 5.52785L0.982584 2.59804C0.907463 2.52292 0.799492 2.48999 0.698437 2.50745C0.594184 2.52534 0.50575 2.59216 0.460279 2.6876C-0.400547 4.49149 -0.0315968 6.65169 1.38015 8.06235C2.27088 8.95306 3.45536 9.44414 4.71557 9.44414Z"
                                            fill="#4682B4"
                                        />
                                        <path
                                            d="M19.4003 14.7836C18.9163 14.7836 18.4409 14.8598 17.9834 15.0059L14.9779 12L12 14.9775L15.0064 17.9839C14.4839 19.6195 14.9138 21.432 16.1332 22.6526C17.0021 23.5215 18.1585 24 19.3863 24C20.0726 24 20.7604 23.8442 21.3776 23.55C21.4708 23.5057 21.536 23.419 21.5534 23.3176C21.5709 23.2161 21.5377 23.113 21.4653 23.04L18.6063 20.1796C18.3958 19.9693 18.2795 19.6899 18.2792 19.3928C18.2792 19.0952 18.3956 18.8158 18.6069 18.6047C19.0282 18.1831 19.7609 18.1834 20.1814 18.605L23.0408 21.464C23.1139 21.5368 23.2158 21.5692 23.3184 21.5524C23.4199 21.5347 23.5065 21.4698 23.5508 21.3766C24.3908 19.6166 24.031 17.5088 22.6535 16.132C21.7846 15.2629 20.629 14.7836 19.4003 14.7836Z"
                                            fill="#4682B4"
                                        />
                                        <path
                                            d="M17.9709 7.96508C17.9709 7.96508 18.4722 8.4219 18.8854 8.20848C19.3525 7.96393 20.6684 9.31378 21.0882 9.62962C21.0895 9.63068 21.0924 9.63068 21.0974 9.63315L20.8679 9.87302C20.5647 10.1848 20.565 10.6939 20.8671 11.0062C21.1693 11.3194 21.6554 11.3191 21.9577 11.0062L23.7748 9.11787C24.075 8.80389 24.0753 8.29569 23.7743 7.98224C23.4744 7.66985 22.9853 7.66985 22.6843 7.9825L22.3817 8.2971C22.1309 7.93775 21.7143 7.32527 21.7671 7.12238C21.9887 6.23377 20.2478 4.13479 20.2478 4.13479C15.9241 -0.36335 13.0361 -0.261108 11.6622 0.23047C11.1107 0.42788 11.2129 0.552941 11.7857 0.657925C15.9541 1.41502 16.4711 3.97285 15.7645 4.95972C15.4928 5.34074 15.8891 5.80074 15.8891 5.80074L16.0381 5.95472L9 13.2769C9.09545 13.3368 9.18819 13.4049 9.26996 13.4902L10.4539 14.721C10.5343 14.805 10.6 14.9008 10.657 15L17.6953 7.67755L17.9709 7.96508Z"
                                            fill="#4682B4"
                                        />
                                        <path
                                            d="M8.66481 14.1981C8.41532 13.9483 7.9907 13.9322 7.72381 14.1641L0.211236 20.9003C-0.0568751 21.1319 -0.0718155 21.526 0.178171 21.7761L2.22444 23.8212C2.47459 24.0712 2.86793 24.0572 3.09923 23.7906L9.83645 16.2746C10.0669 16.0079 10.0523 15.5847 9.80208 15.335L8.66481 14.1981Z"
                                            fill="#4682B4"
                                        />
                                    </svg>

                                    <label class="btn btn-secondary mb-0" for="option2"
                                        >Work Order</label>
                                </div>
                            </div>

                            </b-form-group>



                            <b-form-group>
                            <template v-slot:label>
                                Strata Plan <span class="text-danger">*</span>
                            </template>
                                <b-input-group class="add-input">
                                    <treeselect
                                        v-model="componentForm.strata_plan_id"
                                        :multiple="false"
                                        placeholder="Strata Plan Number"
                                        :defaultOptions="true"
                                        :async="true"
                                        :load-options="loadStrataPlanOptions"
                                        :clearable="true"
                                        :open-on-click="true"
                                        @input="handleStrataPlanSelected($event)"
                                    />


                                    <b-input-group-append class="add-icon">
                                        <!-- <b-button
                                            style="border-radius: 26px;min-width: 100px;font-size: 16px;"
                                            variant="primary"
                                            @click="addStrataPlan"
                                            >+ Add
                                        </b-button> -->
                                        <a href="#" class="" @click= "addStrataPlan"><i class="fa fa-plus-square fa-lg" aria-hidden="true"></i></a>

                                    </b-input-group-append>
                                </b-input-group>


                                <!-- test code -->

                                <!-- if b-input-group is used
                                treeselect does not work hence remove it-->

                                <!-- <b-input-group>
                                    <b-form-input>
                                         <treeselect
                                        v-model="componentForm.strata_plan_id"
                                        :multiple="false"
                                        placeholder="Strata Plan Number"
                                        :defaultOptions="true"
                                        :async="true"
                                        :load-options="loadStrataPlanOptions"
                                        :clearable="true"
                                        :open-on-click="true"
                                        @input="handleStrataPlanSelected($event)"
                                    />
                                    </b-form-input>

                                    <b-input-group-append is-text>
                                       <i class="fa fa-plus-square" aria-hidden="true"></i>
                                    </b-input-group-append>
                                </b-input-group> -->
                                <!-- test code ends -->

                                <has-error
                                    :form="form"
                                    field="strata_plan_id"
                                ></has-error>
                            </b-form-group>


                            <iframe
                                v-if="getStrataPlanMapUrl"
                                :src="getStrataPlanMapUrl"
                                width="100%"
                                height="200"
                                style="border:0;"
                                allowfullscreen=""
                                loading="lazy"
                            ></iframe>
                            <b-form-group class="mt-3"
                                label="Note for address"
                                v-slot="{ ariaDescribedby }"
                            >
                                <b-form-textarea
                                    type="text"
                                    v-model="componentForm.address_note"
                                    :aria-describedby="ariaDescribedby"
                                    placeholder="Enter something..."
                                    rows="3"
                                    max-rows="6"
                                    v-bind:class="{
                                        'is-invalid': form.errors.has(
                                            'address_note'
                                        )
                                    }"
                                ></b-form-textarea>
                                <has-error
                                    :form="form"
                                    field="address_note"
                                ></has-error>
                            </b-form-group>

                            <div v-if="!workOrder">
                                <p>Is this job private?</p>
                                <b-form-group v-slot="{ ariaDescribedby }">
                                    <b-form-checkbox
                                        class="toggler"
                                        switch
                                        size="lg"
                                        type="text"
                                        v-model="componentForm.is_private"
                                        value="1"
                                        unchecked-value="0"
                                        :aria-describedby="ariaDescribedby"
                                        v-bind:class="{
                                            'is-invalid': form.errors.has('is_private')
                                        }"
                                    >
                                        {{ projectVisibilityText }}
                                    </b-form-checkbox>
                                    <has-error
                                        :form="form"
                                        field="is_private"
                                    ></has-error>
                                </b-form-group>
                            </div>

                            <div class="btn-actions">
                                    <b-button
                                        class="back-btn"
                                        :disabled="form.busy"
                                        type="button"
                                        variant="outline-primary"
                                        @click="$router.go(-1)"
                                        >Cancel
                                    </b-button>

                                    <b-button
                                        class="btn-grad btn-next"
                                        :disabled="form.busy"
                                        type="submit"
                                        variant="primary"
                                        >Next
                                    </b-button>
                            </div>

                        </b-form>


                    </div>

                </div>
        </div>
        <!-- form ends -->


    </div>

<!-- new code ends -->

</template>

<script>
import NavBar from "../../../../pages/manager/includes/NavBar.vue";
import SideBar from "../../includes/SideBar.vue";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";
import { HasError } from "vform";
import _ from "lodash";
import {ManagerRouteNames} from "../../../../routeNames";

export default {
    props: ["form", "step", "sidebarListLinks", "eventParentToChildComponentFrom", "workOrder"],
    components: {
        NavBar,
        FooterComponent,
        SideBar,
        HasError,
        Treeselect
    },
    data() {
        return {
            show: true,
            selected: "radio1",
            options: [
                { text: "Quote", value: "radio1" },
                { text: "Work Order", value: "radio2" }
            ],
            componentForm: {
                form_type: "",
                strata_plan_id: null,
                address_note: "",
                is_private: 1,
                strata_plan: [],
                strataDefaultOption: [],
                edit_start_timestamp: "",
            },
            selectedStrataPlan: {},
            jobType: this.workOrder ? this.workOrder : null

        };
    },
    mounted() {
        _.forEach(this.form, (value, field) => {
            if (field in this.componentForm) {
                this.componentForm[field] = value;
            }
        });

        // axios.post("api/manager/quote/filterStrataPlans").then(response => {
        //     this.strata_plan = response.data.strata_plans.map(strata_plan => {
        //         return {
        //             id: strata_plan.id,
        //             label: strata_plan.strata_plan_number
        //         };
        //     });
        // });

       //Called by parent from index page
        this.eventParentToChildComponentFrom.$on('event-parent-child-componentform', this.eventFromParentToChildComponentForm);

        //Remove from session and geeting if the straplan is created when creating workorder or quote
        // if(sessionStorage.getItem('addStrataPlanFromQuote') || sessionStorage.getItem('addStrataPlanFromWorkorder')){
        //        axios
        //         .post("api/manager/quote/getRecentStrataPlan")
        //         .then((response) => {
        //                 this.componentForm.strata_plan_id = response.data.recently_added_strataplan.id;
        //                 this.selectedStrataPlan = response.data.recently_added_strataplan;
        //         });
        // }

        // sessionStorage.removeItem('addStrataPlanFromQuote');
        // sessionStorage.removeItem('addStrataPlanFromWorkorder');
    },

    methods: {
        componentFormSubmitted() {
            this.$emit("componentFormSubmitted", this.componentForm, 1, 1);
        },
        /**
         * Refill component form
         * Upon editing existing quote the asyncronous axios fires this from parent
        */
       eventFromParentToChildComponentForm(value){
            _.forEach(value.data, (value, field) => {
                if (field in this.componentForm) {
                    this.componentForm[field] = value;
                }
            });
        },
        handleStrataPlanSelected(selectedStrataPlan) {
            axios
                .post("api/manager/strata-plan/getDetails", { id: selectedStrataPlan })
                .then((response) => {
                    this.selectedStrataPlan = response.data.strataplan;
                });
        },

        //For Searching Select
        loadStrataPlanOptions({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                axios
                    .post("api/manager/quote/filterStrataPlans", {
                        search_query: searchQuery,
                        include_strata_plan_id_for_quote_id: this.$route.params.id,
                        force_include_strata_plan_id: 1
                    }, {
                        headers: {
                            'X-Disable-Root-Loading': 1,
                        }
                    })
                    .then(response => {
                        let strataPlans = response.data.strata_plans.map((strata_plan , index) => {
                            //Remove from session and geeting if the straplan is created when creating workorder or quote
                           if(index == 0){
                                if(sessionStorage.getItem('addStrataPlanFromQuote') || sessionStorage.getItem('addStrataPlanFromWorkorder')){
                                    this.componentForm.strata_plan_id = strata_plan.id;
                                    this.handleStrataPlanSelected(strata_plan)
                                }
                                sessionStorage.removeItem('addStrataPlanFromQuote');
                                sessionStorage.removeItem('addStrataPlanFromWorkorder');

                            }
                            return {
                                id: strata_plan.id,
                                label: strata_plan.strata_plan_number,
                            };
                        });
                        callback(null, strataPlans);
                    });
            }
        },
        addStrataPlan(){
            if(this.workOrder){
                sessionStorage.setItem('addStrataPlanFromWorkorder', true);
                sessionStorage.removeItem('addStrataPlanFromQuote');
            }else{
                sessionStorage.setItem('addStrataPlanFromQuote', true);
                sessionStorage.removeItem('addStrataPlanFromWorkorder');
            }

            this.$router.push({ name: ManagerRouteNames.strataPLanEdit, params: { id: 'new', step: 1 } })
        }
    },
    computed: {
        projectVisibilityText() {
            return this.componentForm.is_private == 1
                ? "Not visible to public"
                : "Publicly Visible";
        },
        getStrataPlanMapUrl() {
            let url = '';
            if (!_.isEmpty(this.selectedStrataPlan)) {
                url += 'https://www.google.com/maps/embed/v1/place?q=' + this.selectedStrataPlan.street + ' ';
                if(this.selectedStrataPlan.suburb != null){
                    url += this.selectedStrataPlan.suburb + ' ';
                }
                url += this.selectedStrataPlan.state + ', &key=AIzaSyAa9fw7ddNN4grDDjMlmahf4HJJsbPsfyc';
            }
            return url;
        },
    },

    watch: {
        jobType: function(val, oldVal){
           if(val == 'work-order'){
               this.$router.push({ name: 'manager-workorder-edit', params: { id: 'new', step: 1 } })
           }else{
               this.$router.push({ name: 'manager-quote-edit', params: { id: 'new', step: 1 } })
           }
        }
    }
};
</script>

<style scoped>
    .custom-control-label::before
{
    background-color: #AD95F3 !important;
    height: 1.35rem !important;
    top: 0.055rem !important;
}
.custom-control-input:checked ~ .custom-control-label::before
{
    background-color: #5F2EEA !important;
}
.custom-control-input:focus ~ .custom-control-label::before
{
    box-shadow: 0 0 0 0.3rem #e8e0fe !important;
}
.custom-switch .custom-control-label::after
{
    background-color: #ffffff !important;
}
.custom-switch .custom-control-label::before
{
    left: -2.47rem !important;
    width: 2.1rem !important;
    border-radius: 8rem !important;
}

.add-input {
    align-items: center;
    flex-wrap: nowrap;
    gap: 10px;
}

.add-icon {
    background: #eff0f7;
    padding: 1rem;
}

/* .radio-btns-div {
    display: flex;
    flex-wrap: wrap;
    column-gap: 2rem;
} */

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active {
    color: #000;
    background-color: transparent;
}

.radioBtn {
    border: 1px solid #ddd;
    padding-left: 20px;
    margin-bottom: 1rem;
    box-shadow: 1px 1px 5px 0px rgba(221,221,221,0.75);
-webkit-box-shadow: 1px 1px 5px 0px rgba(221,221,221,0.75);
-moz-box-shadow: 1px 1px 5px 0px rgba(221,221,221,0.75);
}
</style>
